import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { AddressFields } from '../../../../common/components/ReduxFormField';
import {
  isOwner,
  currentOrganisationType,
  isBroker,
} from '../../../auth/redux/authActions';
import PostcodeList from '../../../../common/components/Postcode/PostcodeList';
import {
  Box,
  Button,
  HorizontalFormControl,
  NameFields,
  SelectProducts,
} from '../../../../common/components';
import { Col, Row, Form } from 'react-bootstrap';
import { InternalButtonBar } from '../../../layout/components';
import FormGroupRow from '../../../../common/components/FormGroupRow/FormGroupRow';
import AsyncMultiSelectMenu from '../../../../common/components/SelectMenu/AsyncMultiSelectMenu';
import { required } from 'redux-form-validators';
import MultiSelect from '../../../../common/components/Selects/MultiSelect';

const FORM_NAME = 'userForm';

const getFilters = (filterOrgTypeName) => {
  const autoFilters = [
    {
      type: 'name',
      append: isOwner() ? filterOrgTypeName : currentOrganisationType(),
    },
  ];

  if (isBroker()) {
    autoFilters.push({
      type: 'name',
      in: ['Standard (Broker)', 'Essential (Broker)'],
    });
  }
  return autoFilters;
};

const UserForm = ({
  organisationTypeName,
  formValues,
  handleSubmit,
  submitting,
  resource,
  onSave,
  organisationName,
  organisations,
  isOwnerUser,
}) => {
  const resourceAttributes = resource.data.attributes;
  const filterOrgTypeName = organisationTypeName || '';
  const title = resourceAttributes?.full_name ?? `Add New User to ${organisationName}`;
  const autoFilters = useMemo(() => getFilters(filterOrgTypeName), [filterOrgTypeName]);
  return (
    <Box>
      <h2 className={'title-case'}>{title}</h2>
      <Form horizontal onSubmit={handleSubmit(onSave)}>
        <Row>
          <Col sm={6}>
            <NameFields
              baseName="data.attributes"
              label="Name"
              hideTitle
              labelSize={3}
              fieldComponent={Field}
              validate={required({ msg: 'Name is required' })}
            />
          </Col>
          <Col sm={6}>
            <Field
              name="data.attributes.position"
              label="Position"
              labelSize={3}
              component={HorizontalFormControl}
            />
          </Col>
        </Row>

        <Row>
          <Col sm={6}>
            <Field
              name="data.attributes.phone1"
              label="Phone 1"
              labelSize={3}
              component={HorizontalFormControl}
            />
          </Col>
          <Col sm={6}>
            <Field
              name="data.attributes.phone2"
              label="Phone 2"
              labelSize={3}
              component={HorizontalFormControl}
            />
          </Col>
        </Row>
        {isOwnerUser && (
          <Row>
            <Col sm={6}>
              <Field
                name="data.attributes.metadata.phone_extension"
                label="Phone Ext"
                labelSize={3}
                component={HorizontalFormControl}
                fieldSize={4}
              />
            </Col>
          </Row>
        )}

        <Row>
          <Col sm={6}>
            <PostcodeList
              name="data.attributes.address.postcode"
              targetField={'data.attributes.address'}
              label="Postcode"
              formName={FORM_NAME}
              labelSize={3}
              postcodeFieldSize={6}
              smFieldSize={9}
              value={formValues?.data.attributes.address.postcode ?? ''}
            />
          </Col>
          <Col sm={6}>
            <Field
              name="data.attributes.email"
              type="email"
              label="Email"
              labelSize={3}
              component={HorizontalFormControl}
              validate={required({ msg: 'Email is required' })}
            />
          </Col>
        </Row>

        <Row>
          <Col sm={6}>
            <AddressFields
              baseName="data.attributes.address"
              label="Address"
              labelSize={3}
            />
          </Col>
        </Row>

        <div className="hr" />
        {isOwner() && resource.data.id && (
          <FormGroupRow labelSize={2} label={'Organisations'}>
            <Field
              name="data.relationships.organisations.data"
              url={'/organisations?'}
              preSelectedOptions={organisations}
              component={AsyncMultiSelectMenu}
            />
          </FormGroupRow>
        )}

        {!resource.data.id && (
          <FormGroupRow labelSize={2} label={'Roles'}>
            <Field
              name="data.relationships.roles.data"
              source={'roles'}
              autoFilters={autoFilters}
              isClearable
              isObject
              sourceKey={'Multi'}
              component={MultiSelect}
            />
          </FormGroupRow>
        )}

        {isOwner() && (
          <div>
            <FormGroupRow labelSize={2} label={'Products'}>
              <Field
                name="data.relationships.available_products.data"
                component={SelectProducts}
              />
            </FormGroupRow>
          </div>
        )}

        <Row>
          <Col sm={12}>
            <InternalButtonBar
              buttons={[
                {
                  permissions: ['user.edit'],
                  button: (
                    <Button
                      className="pull-right"
                      type="submit"
                      bsStyle="primary"
                      label={'Save User'}
                      isLoading={submitting}
                    />
                  ),
                },
              ]}
            />
          </Col>
        </Row>
      </Form>
    </Box>
  );
};

export default connect((state, ownProps) => {
  return {
    initialValues: ownProps.resource,
    formValues: getFormValues(FORM_NAME)(state),
  };
})(reduxForm({ form: FORM_NAME })(UserForm));
